module.exports = __webpack_public_path__ + "static/media/M&M.79f53f8b.txt";